import { graphql } from '@teachino/shared-infrastructure';

export const reorderItemMutation = graphql(`
  mutation ReorderItem($itemReorderInput: ItemReorderInput!) {
    reorderItem(itemReorderInput: $itemReorderInput) {
      item {
        id
      }
    }
  }
`);
